import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {LEGEND} from "../../config/legend.config";
import {LayerActions, LayerState} from "../../reducers/layer.reducer";
import {Observable} from 'rxjs/Observable';
import {NgRedux, select} from '@angular-redux/store';
import {IAppState} from "../../reducers/root.reducer";

@Component({
  selector: 'app-legend',
  templateUrl: './legend.component.html',
  styleUrls: ['./legend.component.scss']
})
export class LegendComponent implements OnInit, OnChanges {

  legend: any[];

  @Input()
  year: string;

  @Input()
  layers: any[];

  @Input()
  streetOverlayEnabled: boolean;

  constructor( private ngRedux: NgRedux<IAppState>) {  }

  ngOnInit() {
    this.updateLegend();
  }

  toggleStreetOverlay() {
    this.ngRedux.dispatch({type: LayerActions.TOGGLE_STREET_OVERLAY});
  }

  getYears(layers) {
    return layers.map(l => l.year);
  }

  setYear(year){
    this.ngRedux.dispatch({type: LayerActions.SET_YEAR, body: { year: year}});
  }

  ngOnChanges(changes: SimpleChanges): void {

    if(changes.year) {
      this.updateLegend();
    }
  }

  updateLegend(){
    if(this.year){
      const yearLegends = LEGEND.filter(l => l.year === this.year);
      this.legend = yearLegends.length > 0 ? yearLegends[0].legend : [];
    } else {
      this.legend = [];
    }
  }
}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Angular_wig_cropmap_master/src/app/components/legend/legend.component.ts